const putData = adapter => (key, value) => {
  return adapter.callAction('putData', {
    key,
    // An undefined value means no data should be stored/existing
    // data for the key should been erased
    value: value === undefined ? undefined : String(value)
  })
}

export default putData
